import { Controller } from '@hotwired/stimulus'
import Swiper, { Navigation, Pagination, Lazy } from 'swiper/core'

Swiper.use([Navigation, Pagination, Lazy])
export default class extends Controller {
  static targets = ['reviewList', 'nextButton', 'prevButton', 'pagination']

  get className () {
    return this.element.dataset.classname
  }

  connect () {
    const swiper = new Swiper(this.reviewListTarget, {
      slidesPerView: 3,
      spaceBetween: 12,
      navigation: {
        nextEl: this.nextButtonTarget,
        prevEl: this.prevButtonTarget,
      },
      pagination: {
        el: this.paginationTarget,
        clickable: true,
        bulletActiveClass: `${this.className}::active`,
      },
    })
  }
}
